import { Auth, CognitoHostedUIIdentityProvider } from "@aws-amplify/auth";
import { CustomOAuthState } from "../types/CustomOAuthState";

export class AuthUtils {
  private static async refreshSessionPromise(refreshToken: any) {
    const user = await Auth.currentAuthenticatedUser();
    return new Promise((resolve, reject) => {
      return user.refreshSession(refreshToken, async (err: any, data: any) => {
        if (err) {
          reject(err);
        } else {
          resolve(data); // THIS IS YOUR REFRESHED ATTRIBUTES/GROUPS
        }
      });
    });
  }
  public static async refreshCurrentSession() {
    const session = await Auth.currentSession();
    return this.refreshSessionPromise(session.getRefreshToken());
  }

  /**
   * Signs in the user.
   */
  public static async signIn() {
    const customOAuthState: CustomOAuthState = {
      initialPagePath: window.location.pathname
    };
    await Auth.federatedSignIn({
      provider: CognitoHostedUIIdentityProvider.Cognito,
      customState: JSON.stringify(customOAuthState)
    });
  }
}
